;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="a559928a-5b49-494f-91ec-03a93cc1f450",e._sentryDebugIdIdentifier="sentry-dbid-a559928a-5b49-494f-91ec-03a93cc1f450")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useState, useContext } from 'react';
import 'react/jsx-runtime';
import ArrowAngleDown from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/ArrowAngleDown.js';
import ArrowAngleUp from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/ArrowAngleUp.js';
import { Anchor } from '@zooplus/ui-components';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import { isSpecialLink } from '../../utils/categoryUtils.js';
import { ThemedIcon } from '../Icon/Icon.js';
import { LinkTypeEnum } from '../Link/Link.js';
import styles from './CategoryFlyout.module.scss.js';

const MAX_LINKS_SHOWN = 6;
const ExpandableCategoryList = ({ categories, }) => {
    const [showAll, setShowAll] = useState(false);
    const handleToggle = () => {
        setShowAll(!showAll);
    };
    const { translations } = useContext(AppContext);
    const labels = {
        showMore: translations.get('general.show-more'),
        showLess: translations.get('general.show-less'),
    };
    return (React__default.createElement(React__default.Fragment, null,
        categories.map((item, index) => {
            const isSpecial = isSpecialLink(item);
            return (React__default.createElement("li", { key: item.title, className: classNames(styles.groupItem, {
                    [styles.groupItemHidden]: index >= MAX_LINKS_SHOWN && !showAll,
                }) },
                React__default.createElement(Anchor, { variant: isSpecial ? 'danger' : LinkTypeEnum.NEUTRAL, "data-link-type": isSpecial
                        ? LinkTypeEnum.OFFER
                        : LinkTypeEnum.NEUTRAL, className: classNames({
                        [styles.nonBoldSpecialsText]: isSpecial,
                    }, styles.subSpecialOffers), "data-zta": "category-flyout-animal-level4-link", "aria-hidden": index >= MAX_LINKS_SHOWN && !showAll, "aria-label": "group-item", href: item.path }, item.title)));
        }),
        categories.length > MAX_LINKS_SHOWN && (React__default.createElement("li", { className: styles.groupFooter },
            React__default.createElement(Anchor, { onClick: handleToggle, iconRight: () => (React__default.createElement(ThemedIcon, { color: "primary", Icon: showAll ? ArrowAngleUp : ArrowAngleDown, "aria-label": showAll ? labels.showMore : labels.showLess })) }, showAll ? labels.showLess : labels.showMore)))));
};

export { ExpandableCategoryList };
//# sourceMappingURL=ExpandableCategoryLinks.js.map
